module.exports = __webpack_public_path__ + "static/media/goodbye-hello.53753f2f.jpg";